import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

import { SidekickBlock } from "../../blocks/SidekickBlock";

/**
 * toppers LandingPage ``hero_options`` sidekick assembly.
 *
 * FAITHFUL port of the ``cms/landing_page.html`` ``hero_options`` loop: a
 * ``{% for block in self.hero_options %}{% if block.block_type == 'hero_sidekick' %}...``
 * that hand-rendered (NOT via the block's own Meta.template) a page-context
 * wrapper + SHOP NOW button + a trailing border div per ``hero_sidekick`` block:
 *
 *   <div class="l-capped-width home-page-hero-mobile-promo landing-page-hero-mobile-promo">
 *     <div class="...__tagline ...">{{ sidekick.sidekick_tagline }}</div>
 *     <div class="...__copy ...">{{ sidekick.sidekick_description }}</div>
 *     {% if pdp %}<a class="button button--ming ...__button" href="{pdp}"><span>SHOP NOW</span></a>{% endif %}
 *   </div>
 *   <div class="home-page-product-feature__border ...--mobile ...--landing-page"></div>
 *
 * The wrapper + SHOP NOW button + border are PAGE context the standalone
 * ``SidekickBlock`` component cannot resolve on its own, so they live here. The
 * inner tagline/copy divs are delegated to ``<SidekickBlock>`` -- its rendered
 * classnames (``home-page-hero-mobile-promo__tagline
 * landing-page-hero-mobile-promo__tagline`` / ``__copy``, both injected via
 * ``dangerouslySetInnerHTML`` since the sidekick fields are RichTextBlocks)
 * match the ``hero_sidekick`` branch EXACTLY, so we reuse it rather than
 * re-inline the two divs. (See SidekickBlock/index.tsx: it documents itself as
 * the intentional SUBSET render that this page assembly completes.)
 *
 * The SHOP NOW ``<a>`` renders only when ``hero_product_pdp_url`` is truthy
 * (non-empty) -- the ``{% if pdp %}`` gate (the server passes ``''`` when
 * there is no resolvable PDP). ``hero_options`` is a single-block-type
 * StreamField (only ``hero_sidekick``), so there is no silent-drop concern and
 * no StreamField dispatch is needed.
 */
export const LandingPageHeroSidekick = (
    props: Immutable<{
        page: Pick<templates.LandingPageTemplate["page"], "hero_options">;
        hero_product_pdp_url: string | null;
    }>,
): React.JSX.Element => {
    const heroOptions = props.page.hero_options?.value ?? [];
    const pdpUrl = props.hero_product_pdp_url;
    return (
        <>
            {heroOptions.map((block) => (
                <React.Fragment key={block.id}>
                    <div className="l-capped-width home-page-hero-mobile-promo landing-page-hero-mobile-promo">
                        <SidekickBlock value={block.value} />
                        {pdpUrl ? (
                            <a
                                className="button button--ming home-page-hero-mobile-promo__button"
                                href={pdpUrl}
                            >
                                <span>SHOP NOW</span>
                            </a>
                        ) : null}
                    </div>
                    <div className="home-page-product-feature__border home-page-product-feature__border--mobile home-page-product-feature__border--landing-page"></div>
                </React.Fragment>
            ))}
        </>
    );
};
